import MainPage from "./Components/MainPage/MainPage"
import "./App.css"

function App() {
  return (
    <>
        <MainPage/>
           
        </>
  );
}

export default App;
